<template>
  <div>
    <Fob :type="'Secondary'" class="border-red-600" @click="toggleOpen">
      <div class="relative flex items-center justify-center">
        <div
          class="absolute inline-flex items-center justify-center w-5 h-5 text-xxs font-bold text-white bg-red-600 border-2 border-white rounded-full -top-2 -right-2"
        >
          {{ unassignedEvents.length }}
        </div>
        <WarningIcon class="h-5 text-yellow-700" />
      </div>
    </Fob>
    <Modal
      v-if="open"
      title="Unassigned Events"
      no-footer
      @hide-modal="toggleOpen"
    >
      <UnassignedEvents />
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import Modal from "@/components/Modal.vue";
import Fob from "@/components/Seranova/Fobs/Fob.vue";
import WarningIcon from "@/images/alert-triangle.svg?component";
import { useEventCalendar } from "@/SchedulerV2/useEventCalendar";
import UnassignedEvents from "./UnassignedEvents.vue";

const { unassignedEvents } = useEventCalendar();

const open = ref(false);

onMounted(() => {
  window.closeUnassignedModal = () => (open.value = false);
});

const toggleOpen = () => (open.value = !open.value);
</script>
